export enum UIButtons {
    GAME_RULES = 'gameRules',
    AUTOPLAY = 'autoplay',
    INFO = 'info',
    BET = 'bet',
    TURBO = 'turbo',
    HOME = 'home',

    // on mobile
    MENU = 'menu',
    TOTAL_BET_OPEN_BUTTON = 'totalBetOpenButton',
    GAME_HISTORY = 'gameHistory'
}
